import { render, staticRenderFns } from "./invoice_records.vue?vue&type=template&id=1f7a5084&"
import script from "./invoice_records.vue?vue&type=script&lang=js&"
export * from "./invoice_records.vue?vue&type=script&lang=js&"
import style0 from "./invoice_records.vue?vue&type=style&index=0&id=1f7a5084&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports